/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observer } from "mobx-react";
import { injectIntl } from "react-intl";
import HeaderContainerBase from "bundle/preview/react-component/header/container/HeaderContainer";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import IFrameMessageTypes from "common/constants/IFrameMessageTypes";

/**
 * Container component for header
 */
@observer
class HeaderContainer extends HeaderContainerBase {
    constructor() {
        super();
        this._scrollingInProgress = false;
        this._setToTop = 0;
        this._timeout = undefined;
        this._heightInView = {};
        if (this._appStore.isInLinePreset) {
            ServiceRegistry.getService("MessagingService").listenForType(
                IFrameMessageTypes.HEIGHT_IN_VIEW,
                typeData => this._gotHeightInView(typeData),
            );
        }
    }

    _gotHeightInView(heightInView) {
        this._heightInView = heightInView;
        const newTop = Math.floor(heightInView.viewStartH);
        if (newTop > 0 && !this._appStore.autoFSStopped
            && this._appStore.getActionConfig("preview").enableAutoFullScreen) {
            this._appStore.setInFullScreen(true);
            return;
        }
        this._setToTop = newTop;
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
        this._appStore.setHeightInView(this._heightInView); // send all events to preview dropin
        this._timeout = setTimeout(() => this._correctTop(), 70);
        if (!this._scrollingInProgress) {
            this._scrollingInProgress = true;
            if (this._headerRef && this._headerRef.style) {
                this._headerRef.style.top = "0px";
                if (this._appStore.searchOpen) {
                    this._adjustSearchUI(0);
                }
            }
        }
    }

    _correctTop() {
        if (this._headerRef && this._headerRef.style) {
            this._headerRef.style.top = `${ this._setToTop }px`;
            this._timeout = undefined;
            this._scrollingInProgress = false;
            if (this._appStore.searchOpen) {
                this._adjustSearchUI(this._setToTop);
            }
        }
    }
}

export default injectIntl(HeaderContainer);
